export default {
    earned: {
        diamond: 10_000_000,
        gold: 1_000_000,
        silver: 100_000,
        bronze: 10_000,
    },
    boosters_opened: {
        diamond: 100_000,
        gold: 10_000,
        silver: 5_000,
        bronze: 1_000,
    },
    sold_cards: {
        diamond: 1_000_000,
        gold: 100_000,
        silver: 10_000,
        bronze: 1_000,
    },
}
